<template>
<div>
  <div>
    <div class="row-container marginb hidden" >
      <div class="search-container">
        <input type="text" class="search-bar" placeholder>
        <a href="#">
          <img class="search-icon" src="@/assets/magnifying-glass.png">
        </a>
      </div>
      <div class="spacer" />
      <div class="row-container align-center">
        <img src="@/assets/group-5.svg" class="Group-5" />
        <button class="text-green" @click="$router.push(`/onboarding/entity/${$route.params.entity_index}/preferences/addStructure`)">Create New Structure</button>
      </div>
    </div>
    <data-table 
    :columns=" columnNames" 
    :tableData="componentsData" 
    :checkbox="false" :withForm="false"
    :showhistory="false" 
    @delete="deleteItem"
    @editStart="editItem"
    />

     <form-add-button class="margin-t-xl" v-show="showAddBtn" main_text="+ Add New" sub_text="Salary Sturcture" @click="goToSalaryStructure()">
    </form-add-button>

  </div>
  <!-- <bottom-action-container>
    <btn-skip @navClicked="$emit('stepNum', 4)"></btn-skip>
    <template slot="end">
      <btn-grp>
        <btn text="Previous" type="secondary" @click="$emit('stepNum', 2)"/>
        <btn text="Next" type="primary" @click="$emit('stepNum', 4)" />
      </btn-grp>
    </template>
  </bottom-action-container> -->
</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

import {
  structure
} from "@/assets/data/salaryStructure.js";
export default {
  name: 'SalaryStructure',
  props:{
    tabIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      structureData: structure,
      showAddBtn: true,
      columnNames: [{
          label: 'Name',
          key: 'name'
        },
        // {
        //   label: 'Legal Entity',
        //   key: 'legalEntity'
        // },{
        //   label: 'Pay Group',
        //   key: 'payGroup'
        // },
        {
          label: 'Criteria',
          key: 'criteria'
        },
        {
            label: "Sub-Criteria",
            key: "criteria"
          },
        {
          label: 'Modified date',
          key: 'modifiedDate'
        },
      ]
    }
  },
  computed: {
    ...mapState({
      salaryStructureData: state =>
        state.onboard.settings.salary_structure.entityWiseData
    }),
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID"
    }),
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      }
      return this.getLegalEntityId(0);
    },
    orgId() {
      return this.$store.getters["onboard/getOrgId"];
    },
    componentsData() {
      // for (let i = 0; i < this.salaryComponentsData[this.leId].length; i++) {
      //   this.salaryComponentsData[this.leId][i].type = this.componentTypes
      // }
      // //console.log('dddd'+this.salaryComponentsData[this.leId]);
     // let le_id = "f2bd8f30-b270-40b9-942e-7ae917d73782";
      return this.salaryStructureData[this.leId];
    }
  },
  mounted() {
    this.fetchAllSalaryStructureData();
  },
   activated() {
     this.fetchAllSalaryStructureData();
   },
  methods: {
    ...mapActions({
      act_fetchAll: "onboard/settings/salary_structure/fetchAll",
      act_delete: "onboard/settings/salary_structure/delete"
    }),
    navHandler(navType) {
      if (navType == 'back') {
        this.$emit('stepNum', 2);
        this.$validator.reset();
      }
      if (navType == 'next') {
        this.$emit('stepNum', 4);
        this.$validator.reset();
      }
    },
    goToSalaryStructure(){
      // this.$router.push({
      //   path: `/onboarding/entity/${this.$route.params.entity_index}/preferences/addStructure`,
      // });
      // this.tabIndex = 0;
      this.$emit('changeTabIndex', 0);
    },
    async fetchAllSalaryStructureData() {
      try {
        let le_id = "f2bd8f30-b270-40b9-942e-7ae917d73782";
        let res = await this.act_fetchAll(le_id);
        if (res.message != null) {
          throw Error(res.message);
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    async deleteItem(rec) {
      try {
        await this.act_delete(rec);
      } catch (err) {
        //console.log(err);
      }
    },
    async editItem(rec) {
      this.$router.push({
        path: `/onboarding/entity/${
          this.$route.params.entity_index
        }/preferences/modifystructure`,
        query: { id: rec.id  }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.Group-5 {
    width: 24px;
    height: 24px;
    object-fit: contain;
}
.text-green {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: bold;
    color: #37c6c0;
}
.search-bar {
    width: 321px;
    border: 1px solid #d6d4d4;
    border-radius: 3px;
    height: 30px;
    padding: 5px;
    outline: none;
    position: relative;
}
.marginb {
    margin-bottom: 18px;
}
.search-icon {
    position: absolute;
    left: 295px;
    top: 6px;
    width: 18px;
    height: 18px;
}
.search-container {
    position: relative;
}
.align-center {
    align-items: center;
}
</style>
